import { selectExperiments } from '../selectExperiments';
import { IAppState } from 'shared/common/state';
import { NEWBUILDING_BROKER_SELF_REQUEST_FORM } from 'shared/constants/experiments';
import { isAbUseExperimentGroup } from 'shared/utils/experiments/isAbUseExperimentGroup';

// TODO: Удалить в CD-243911 после завершения эксперимента.
export const selectIsSelfRequestFormExperiment = (state: IAppState) => {
  const experiments = selectExperiments(state);

  return isAbUseExperimentGroup(experiments, NEWBUILDING_BROKER_SELF_REQUEST_FORM, 'B');
};
